module.exports = __webpack_public_path__ + "img/finance_cooperate3.107876b6.png";